import React from "react";

export default function ImageIcon({ color = "currentColor" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1449_9849)">
        <path
          d="M19.6516 17.8835L16.5257 21.8692L14.8744 19.7638C14.8443 19.7254 14.8059 19.6944 14.762 19.673C14.7182 19.6516 14.67 19.6405 14.6213 19.6405C14.5725 19.6405 14.5243 19.6516 14.4805 19.673C14.4366 19.6944 14.3982 19.7254 14.3681 19.7638L10.3583 24.8746C10.3212 24.9219 10.2982 24.9788 10.2919 25.0386C10.2856 25.0985 10.2962 25.1589 10.3226 25.2129C10.3491 25.267 10.3901 25.3125 10.4412 25.3444C10.4923 25.3762 10.5513 25.393 10.6114 25.3929H25.3931C25.6623 25.3929 25.811 25.0835 25.6463 24.8746L20.1619 17.8835C20.1314 17.845 20.0926 17.8139 20.0485 17.7926C20.0043 17.7712 19.9558 17.7601 19.9068 17.7601C19.8577 17.7601 19.8092 17.7712 19.765 17.7926C19.7209 17.8139 19.6821 17.845 19.6516 17.8835ZM11.8931 15.1875C11.8931 15.6137 12.0625 16.0225 12.3639 16.3239C12.6653 16.6253 13.074 16.7946 13.5003 16.7946C13.9265 16.7946 14.3353 16.6253 14.6367 16.3239C14.9381 16.0225 15.1074 15.6137 15.1074 15.1875C15.1074 14.7613 14.9381 14.3525 14.6367 14.0511C14.3353 13.7497 13.9265 13.5804 13.5003 13.5804C13.074 13.5804 12.6653 13.7497 12.3639 14.0511C12.0625 14.3525 11.8931 14.7613 11.8931 15.1875ZM31.7655 9.02411L23.119 0.377679C22.878 0.136607 22.5525 0 22.211 0H5.14314C4.43198 0 3.85742 0.574554 3.85742 1.28571V34.7143C3.85742 35.4254 4.43198 36 5.14314 36H30.8574C31.5686 36 32.1431 35.4254 32.1431 34.7143V9.93616C32.1431 9.59464 32.0065 9.26518 31.7655 9.02411ZM29.178 10.5268H21.6164V2.96518L29.178 10.5268ZM29.2503 33.1071H6.75028V2.89286H18.8842V11.5714C18.8842 12.019 19.062 12.4482 19.3785 12.7647C19.6949 13.0811 20.1242 13.2589 20.5717 13.2589H29.2503V33.1071Z"
          fill="black"
          fillOpacity="0.85"
        />
      </g>
      <defs>
        <clipPath id="clip0_1449_9849">
          <rect
            width="36"
            height="36"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
